'use client';
import { PropsWithChildren, ReactNode } from 'react';
import {
  FieldValues,
  SubmitHandler,
  FormProvider,
  UseFormReturn
} from 'react-hook-form';

interface Props {
  id: string;
  className?: string;
  formMethods: UseFormReturn<FieldValues>;
  onSubmit: SubmitHandler<FieldValues>;
  children: ReactNode;
}

export const AssociatedDealerForm = ({
  id,
  className,
  formMethods,
  onSubmit,
  children
}: PropsWithChildren<Props>) => {
  return (
    <FormProvider {...formMethods}>
      <form
        id={id}
        data-testid="select-customer-form"
        className={className}
        onSubmit={formMethods.handleSubmit((data) => {
          if (onSubmit) {
            onSubmit(data);
          }
        })}
      >
        {children}
      </form>
    </FormProvider>
  );
};
